import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import JobsGrouped from "./JobsGrouped";
import Unauthorized from "components/UI/Unauthorized";
import { usePermissions } from "context/PermissionsContext";
import { t } from "i18next";

function JobsClassic() {
  const { hasPermission } = usePermissions();

  if (!hasPermission("can_view_gwm")) {
    return <Unauthorized />;
  }

  const pagesList = [{ name: t("lang.jobs") || "Jobs", route: "" }];

  return (
    <DashboardLayout>
      <DashboardNavbar pagesList={pagesList} />
      <Card sx={{ mt: 2 }}>
        <SoftBox p={3}>
          <JobsGrouped />
        </SoftBox>
      </Card>
    </DashboardLayout>
  );
}

export default JobsClassic;
